
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mypage/info/marketing-agreement",
      function () {
        return require("private-next-pages/mypage/info/marketing-agreement.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mypage/info/marketing-agreement"])
      });
    }
  